(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('vatReports', {
        templateUrl: 'views/components/views/vatReports/vatReports.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'vatReportsService', 'logisticService', 'accountingBsService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, vatReportsService, logisticService, accountingBsService, ttGridFactory, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            let variableNames = {
                businessco_no: '',
                accounting_year: ''
            };

            vm.model = {
                gridReady: false,
                setting: {},
                selectListCompanies: [],
                selectListAccountingYears: []
            };

            vm.grid = new ttGridFactory({
                rememberId: 'w_vatreports_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'vatreports_new',
                    text: 'vatreports_new',
                    func: () => {
                        stateService.go('vatreport', {
                        	businessco_no: vm.model.setting.businessco_no,
                            accounting_year: vm.model.setting.accounting_year,
                            vatreport_keyno: '0'
                        });
                    },
                    icon: 'fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
            
            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await vatReportsService.getSetting())[0];
            }

            async function loadCompanies() {
                vm.model.selectListCompanies = await logisticService.listCompanies();
            }

            async function loadAccountingYears() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                return vm.model.selectListAccountingYears = await accountingBsService.listAccountingYears({ businessco_no: vm.model.setting.businessco_no });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 3129,
                    parameters: vm.model.setting
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }
            
            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'businessco_no':
                            variableNames[key] = 'w_accountingprocessing' + '.' + key;
                            break;
                        case 'accounting_year':
                            variableNames[key] = stateService.getCurrentName() + '.' + key;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'businessco_no':
                    case 'accounting_year':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                        vm.model.setting.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        Promise.all([
                            rememberFunc('businessco_no'),
                            loadAccountingYears()
                        ]).then(() => {
                            loadGrid();
                            Promise.resolve();
                        });
                        break;
                    case 'accounting_year':
                        if (utilityService.validateWatchValue(value, vm.model.setting.accounting_year) !== true) return;

                        vm.model.setting.accounting_year = value;

                        if (utilityService.validateParmsValue(vm.model.setting.accounting_year, true) !== true) return;

                        Promise.all([
                            rememberFunc('accounting_year')
                        ]).then(() => {
                            loadGrid();
                            Promise.resolve();
                        });
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
            	await loadSetting();
                loadCompanies();

                return Promise.all([
                    loadAccountingYears()
                ]).then(() => {
                    loadGrid();
                    Promise.resolve();
                });
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
